export const getClimateIncidentsTypes = state => state.climateInsightsTimeline.incidentsTypes;
export const getIsIncidentsTypesFetching = state => state.climateInsightsTimeline.isIncidentsTypesFetching;
export const getClimateIncidentsTree = state => state.climateInsightsTimeline.timelineData;
export const getExpandedNodes = state => state.climateInsightsTimeline.expanded;
export const getLoadedNodes = state => state.climateInsightsTimeline.loadedNodes;
